import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import TextField, {
  TextFiledType,
} from '../../../../../../../components/common/textField';
import { Visibility } from '../../../../../../../types/common-types';
import { useDidMount } from '../../../../../../../components/common/effects';
import './style.scss';
import loadScript from '../widget/components/loadScript';


interface ValueProps {
  id: string;
  value: string;
  error: boolean;
}
interface Props {
  id: string;
  title?: string;
  value?: string;
  extra?: { length: number };
  error?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  regexp?: string;
  required?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  type?: TextFiledType;
  visibility?: Visibility;
  length?: number;
  onSubmit: (id: string) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
  submitOnChange?: boolean;
  nonPasteable?: boolean;
}

declare global {
  interface Window { IGLOO: any; }
}



const Blackbox: React.FC<Props> = ({
  id,
  title,
  //value = useBlackboxString(1),
  visibility,
  type,
  extra = {},
  required,
  placeholder,
  regexp,
  errorMsg,
  helpMsg,
  error,
  onChange,
  onSubmit,
  submitOnChange = false,
  nonPasteable = false,
}) => {

  var [value, setValue] = useState();
  var blackbox = useBlackboxString(1);
  value = blackbox;
  const didMount = useDidMount();
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (didMount && submitOnChange) onSubmit(id);
    }, 100);
    return () => clearTimeout(timeout);
  }, [value]);
  return (
    <div>
      <TextField
        id={id}
        className="blackbox"
        styleName={cn('edit')}
        type={type}
        label={title}
        visibility={visibility}
        value={value ?? ""}
        error={error}
        placeholder={placeholder}
        required={required}
        regexp={regexp}
        length={extra.length}
        helperText={error ? errorMsg : helpMsg}
        onChange={onChange}
        nonPasteable={nonPasteable}
      />

    </div>

  );
};

export default Blackbox;

var timeoutId: NodeJS.Timeout;

function useBlackboxString(_intervalCount: any) {
  if (typeof window.IGLOO.getBlackbox !== 'function') { return; }

  var bbData = window.IGLOO.getBlackbox();
  if (bbData.finished) {
    clearTimeout(timeoutId);
    var blackBoxString = bbData.blackbox;
    return blackBoxString;
  }
}
timeoutId = setInterval(useBlackboxString, 500);


const mulitpleLoadScript = (id: string, src: string, callback: () => void) => {
  const existingScript = document.getElementById('externalScript');
  if (!existingScript) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = require(src);
    script.id = id;
    script.onload = () => {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }
  if (existingScript && callback) callback();
};

